import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import CopyButton from './CopyButton'

// Natura answers with a JSON object on some paths and a bare string on others,
// and a timeout leaves nothing at all. All three have to render.
export const asText = body => {
  if (body === null || body === undefined) return ''
  if (typeof body === 'string') return body
  return JSON.stringify(body, null, 2)
}

export default function JsonBlock({ heading, body, emptyLabel }) {
  const { t } = useTranslation()
  const text = asText(body)

  return (
    <div className="mb-4">
      <div className="flex items-center justify-between mb-1">
        <h3 className="text-sm font-semibold text-gray-700">{heading}</h3>
        {text !== '' && <CopyButton text={text} />}
      </div>
      {text === '' ? (
        <p className="text-sm text-gray-500 italic">{emptyLabel || t('natura_operations.shared.empty_body')}</p>
      ) : (
        <pre className="text-xs bg-gray-50 border border-gray-200 rounded p-2 max-h-96 overflow-auto whitespace-pre-wrap break-words">{text}</pre>
      )}
    </div>
  )
}

JsonBlock.propTypes = {
  heading: PropTypes.string.isRequired,
  body: PropTypes.any,
  emptyLabel: PropTypes.string,
}

JsonBlock.defaultProps = {
  body: null,
  emptyLabel: null,
}
